export const allowedPositions = ['left', 'center', 'right']
export const allowedSizes = ['extrasmall', 'small20', 'small', 'medium', 'medium16', 'large', 'extraLarge']
export const allowedFontWeights = ['mediumbold', 'semibold', 'bold']
